import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

// import Colors from '../../resource/ResourceColors.jsx';

export const TIME_SIGNATURE_HEIGHT_REM = 2;

const TimeSignatureBar = styled.div`
    position:relative;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
`;

export class TrackTimeSignatureEvents extends Component {

    static propTypes = {
        zoom_factor: PropTypes.number.isRequired,
        time_signature_events: PropTypes.array.isRequired,
    }

    state = {
        zoom_factor: this.props.zoom_factor
    };

    set_zoom_factor(zoom_factor) {
        this.setState({zoom_factor: zoom_factor})
    }

    render() {
        console.log('this.props.time_signature_events', this.props.time_signature_events);
        return <TimeSignatureBar>'track time signature'</TimeSignatureBar>
    }
}

export default TrackTimeSignatureEvents;

